import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

export const Description = styled('div')(({ theme }) => ({
  '&&': {
    fontWeight: theme.fontWeight.bold,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1)
  }
}));

export const Image = styled('img')(({ theme, $active }) => ({
  width: '180px',
  height: '230px',
  objectFit: 'cover',
  border: '2px solid transparent',
  ...($active && {
    border: `2px solid ${theme.color.primary.main}`,
    boxShadow: `0 0 10px ${theme.color.primary.main}`
  })
}));

export const Label = styled('p')(({ theme, mt, mb }) => ({
  color: '#666666',
  fontSize: theme.fontSize.small,
  marginTop: mt ? `${mt}px` : '0px',
  marginBottom: mb ? `${mb}px` : '0px'
}));

export const MuiGrid = styled(Grid)(() => ({
  alignItems: 'center'
}));

export const GridContainer = styled('div')(() => ({
  '& .MuiGrid-spacing-xs-3': {
    width: '110% !important'
  }
}));

export const BoxContainer = styled('div')(() => ({
  display: 'flex'
}));

export const Box = styled('div')(({ theme, color, $active }) => ({
  width: '20px',
  height: '20px',
  background: color || '#ffffff',
  border: '2px solid rgba(0, 0, 0, 0.2)',
  marginLeft: '8px',
  ...($active && {
    border: `2px solid ${theme.color.primary.main}`,
    boxShadow: `0 0 10px ${theme.color.primary.main}`
  })
}));
